import MainLayout from "@/components/layout/MainLayout";
import { SEO } from "@/components/seo/SEO";
import { AIWorkflowController } from "@/components/ai/AIWorkflowController";
import { AIDataAssistant } from "@/components/ai/AIDataAssistant";
import { UniversalDataAnalyzer } from "@/components/ai/UniversalDataAnalyzer";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { WorkflowTemplatesLibrary } from "@/components/workflow/WorkflowTemplatesLibrary";
import { Bot, Workflow, Brain, LayoutTemplate } from "lucide-react";
import { useState } from "react";

const AIWorkflows = () => {
  const [activeTab, setActiveTab] = useState("analyzer");

  const handleTemplateSelect = (config: any) => {
    setActiveTab("pipeline");
  };

  return (
    <MainLayout>
      <SEO title="AI Workflows — Veylo AI" description="Analyse a file, ask questions about your data, run automated AI pipelines and start from ready-made workflow setups." path="/ai-workflows" />
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold">AI Workflows</h1>
          <p className="text-muted-foreground">
            Upload a file to get answers about your data, ask questions in plain English,
            or let the app do the whole job for you.
          </p>
        </div>
        <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
          <TabsList className="grid w-full grid-cols-2 md:grid-cols-4">
            <TabsTrigger value="analyzer" className="gap-2">
              <Brain className="h-4 w-4" />
              Analyse a file
            </TabsTrigger>
            <TabsTrigger value="assistant" className="gap-2">
              <Bot className="h-4 w-4" />
              Ask a question
            </TabsTrigger>
            <TabsTrigger value="pipeline" className="gap-2">
              <Workflow className="h-4 w-4" />
              Do it for me
            </TabsTrigger>
            <TabsTrigger value="templates" className="gap-2">
              <LayoutTemplate className="h-4 w-4" />
              Ready-made setups
            </TabsTrigger>
          </TabsList>
          <TabsContent value="analyzer" className="mt-4">
            <UniversalDataAnalyzer />
          </TabsContent>
          <TabsContent value="assistant" className="mt-4">
            <AIDataAssistant />
          </TabsContent>
          <TabsContent value="pipeline" className="mt-4">
            <AIWorkflowController />
          </TabsContent>
          <TabsContent value="templates" className="mt-4">
            <WorkflowTemplatesLibrary onSelectTemplate={handleTemplateSelect} />
          </TabsContent>
        </Tabs>
      </div>
    </MainLayout>
  );
};

export default AIWorkflows;
